import axios from 'axios'
import { getUserId } from '../common/userIdService';
const orgId = "cdp3d";


export const backendUrl = 'https://backend.cdp3d.com'; // Base URL for backend
// export const backendUrl = 'http://localhost:4000'
export const url = `${backendUrl}/${orgId}`; // Org-specific URL
const fallbackUrl = 'https://backend.cdp3d.com';
// export const url = 'https://backend.cdp3d.com/' + orgId;
// export const url = 'http://localhost:5000/' + orgId;

// alert(url)

let userId = getUserId();

export const uploadModelFile = (file) => {
  const formData = new FormData();
  formData.append('modelFile', file);
  return axios.post(`${backendUrl}/api/upload-model`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getBooksPaginated = (pageNo, pageSize) => axios.get(`${url}/products?pageNo=${pageNo}&pageSize=${pageSize}`);

export const getBook = (id) => axios.get(`${url}/products/${id}`);
// export const getBooksBySearch=(searchQuery)=>axios.get(`${url}/books/search?searchQuery=${searchQuery.search || 'none'}&tags=${searchQuery.tags}`);
export const updateCart = (cart) => axios.post(`${url}/cart`, cart);

export const getSearchResults = (searchTerm) => axios.get(`${url}/products/search/${searchTerm}`);

export const placeOrder = (cart) => axios.post(`${url}/orders`, {...cart, userId, orgId });

export const getCoupon = (coupon) => axios.get(`${url}/coupons/code/${coupon}`);

export const getRazorpayKey = () => axios.get(`${url}/orders/razorpay`);

export const logEvent = () => axios.post(`${fallbackUrl}/event`, { userId });

export const commonFetch = (postUrl) => axios.get(url + postUrl)

export const createPaymentEvent = (orderData) => axios.post(`${url}/orders/create-payment-event`, orderData);

// Reviews
export const getReviews = (productId) => axios.get(`${backendUrl}/reviews/${productId}`);
export const addReview = (reviewData) => axios.post(`${backendUrl}/reviews`, reviewData);
export const deleteReview = (reviewId) => axios.delete(`${backendUrl}/reviews/${reviewId}`);